var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useJoinRoomMutation } from '../../../../store/services/breakoutRoomApi';
import { store } from '../../../../store';
import { JoinBreakoutRoomReq } from '../../../../helpers/proto/plugnmeet_breakout_room_pb';
const JoinBtn = ({ breakoutRoomId }) => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const [disable, setDisable] = useState(false);
    const [token, setToken] = useState('');
    const [joinRoom, { isLoading, data }] = useJoinRoomMutation();
    useEffect(() => {
        setDisable(!!isLoading);
    }, [isLoading]);
    useEffect(() => {
        var _a;
        if (!isLoading && data) {
            if (!data.status) {
                toast(t(data.msg), {
                    type: 'error',
                });
                return;
            }
            setToken((_a = data.token) !== null && _a !== void 0 ? _a : '');
        }
    }, [data, isLoading]);
    useEffect(() => {
        if (token !== '') {
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.set('access_token', token);
            const url = location.protocol +
                '//' +
                location.host +
                window.location.pathname +
                '?' +
                searchParams.toString();
            const opened = window.open(url, '_blank');
            if (!opened) {
                toast(t('breakout-room.open-tab-error'), {
                    type: 'error',
                });
            }
        }
    }, [token]);
    const join = () => {
        var _a, _b;
        joinRoom(new JoinBreakoutRoomReq({
            breakoutRoomId: breakoutRoomId,
            userId: (_b = (_a = store.getState().session.currentUser) === null || _a === void 0 ? void 0 : _a.userId) !== null && _b !== void 0 ? _b : '',
        }));
    };
    return (_jsx("div", { className: "join-btn mr-4", children: _jsx("button", { className: "text-center py-1 px-3 mt-1 text-xs transition ease-in bg-primaryColor hover:bg-secondaryColor text-white font-semibold rounded-lg", onClick: join, disabled: disable, children: t('breakout-room.join') }) }));
};
_react_refresh_temp_1 = JoinBtn;
$RefreshReg$(_react_refresh_temp_1, "JoinBtn");
_react_refresh_temp_2(JoinBtn, "TGhQ0iN5ZQHcfYzNBgafc51+hjQ=", false, () => [useTranslation, useJoinRoomMutation]);
export default JoinBtn;
